import {
  InfoPanelTitle,
  InfoPanelDescription,
  InfoPanelLinks,
  InfoPanelFooter,
} from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InfoPanel'

export function RentalIncomeTaxTreatmentInfoContent() {
  return (
    <>
      <InfoPanelTitle>
        How is your rental income treated for tax purposes?
      </InfoPanelTitle>
      <InfoPanelDescription>
        <p>
          How your rental income is treated for tax purposes depends on how much
          you were involved in managing your rental this year. The IRS uses this
          to determine if your income is passive or non-passive, which affects
          how you use losses and whether certain taxes may apply.
        </p>
        <p>
          <strong>Options:</strong>
        </p>
        <p>
          <strong>Passive rental activity:</strong> You do not take part in
          managing your rental in a regular or meaningful way. Most rentals fall
          in this category. Passive income may be subject to the Net Investment
          Income Tax.
        </p>
        <p>
          <strong>Non-passive rental activity:</strong> You are actively
          involved in decisions such as setting rent, choosing tenants, or
          coordinating repairs. This makes the activity non-passive.
        </p>
      </InfoPanelDescription>
      <InfoPanelFooter>
        <InfoPanelLinks
          links={[
            {
              label: 'Instructions for Form 8960, Net Investment Income Tax',
              url: 'https://www.irs.gov/instructions/i8960',
            },
          ]}
        />
      </InfoPanelFooter>
    </>
  )
}
